<template>
  <div class="main-home" style="margin-left:20px">
    <HeaderPage @language-change="languageChange" />
    <div style="display:flex;width:1920px">
      <el-form style="display:inline-block;margin-top:20px;margin-left:0px">
        <el-form-item>
          <el-select v-model="demoName" :placeholder="$t('Main.Select_template')">
            <el-option v-for="item in demoList" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>

        </el-form-item>
      </el-form>
      <el-button @click="downloadTemplate"
        style="margin-top:20px;background:#0049c8;color:#ffffff;display:inline-block;width:150px;height: 40px;margin-left:20px;font-size:5px">{{
          $t('Main.Download_Template') }}</el-button>
      <div style="display:space-between;width:60%">
        <el-upload class="upload-demo" ref="upload" :show-file-list=false :action="uploadFileUrl" :on-change="check"
          :file-list="fileList" :auto-upload="false">
          <el-input v-model="fileName" slot="trigger" :readonly='true' :placeholder="$t('Main.Select_File')"
            style=";margin-top:20px;margin-right:20px;width:300px;display:inline-block;"></el-input>
          <el-button
            style="margin-top:20px;background:#0049c8;color:#ffffff;display: inline-block;width:150px;font-size:5px"
            @click="showDataUpdateDialog">{{ $t('Main.Upload_Data') }}</el-button>
        </el-upload>
      </div>
      <span v-show="isUploadProgress" style="font-size: 12px;margin-right: 20px;margin-top: 12px;margin-bottom: auto;">{{
        uploadFileName }}</span>
      <div>
        <div v-show="isUploadProgress" style="margin:8px;margin-top:12px;display: flex;height: 40%;">
          <ProgressBar :progress="Number(uploadProgressPercent)" :width="100" style="display:inline-block;" />
          <span v-if="uploadProgressPercent < 100" style="font-size: 12px;">{{ $t('Main.Uploading') }}</span>
          <span v-if="isFileUploadSuccess" style="font-size: 12px;">{{ $t('Main.Uploaded') }}</span>
          <span v-if="uploadProgressPercent >= 100 && !isFileChecked" style="font-size: 12px;">{{
            $t('Main.File_Validating') }}</span>
          <span v-if="!isFileUploadSuccess && isFileChecked" style="font-size: 12px;">{{ $t('Main.Format_error') }}</span>
        </div>
        <div v-show="isDiagnoseProgress" style="margin:8px;display: flex;height: 40%;">
          <ProgressBar :progress="Number(diagnoseProgress)" :width="100" style="display:inline-block;" />
          <span v-if="diagnoseProgress < 100" style="font-size: 12px;">{{ $t('Main.Diagnosing') }}</span>
          <span v-if="diagnoseProgress >= 100" style="font-size: 12px;">{{ $t('Main.Diagnosed') }}</span>
        </div>
      </div>
      <DataUploadDialog :is-show="dialogVisible" :project-list="projectList" :current-time="currentTime"
        @closeDialog="closeDialog()" @diagnoseNow="diagnoseNow(arguments)" @diagnoseLater="diagnoseLater(arguments)" />
    </div>
    <!-- 根据项目名筛选 -->
    <div style="border-radius:12px;border:1px solid #dcdfe6;padding:20px;margin-top:10px">
      <div>
        <el-form style="display:flex;margin-top:30px">
          <el-form-item>
            <el-select v-model="projectName" :placeholder="$t('Main.Select_Project')">
              <el-option v-for="item in projectList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <el-button @click="resetTable"
              style="margin-left: 20px;background:#0049c8;color:#ffffff;display:inline-block;width:150px;font-size:5px">{{
                $t('Main.Reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <DataTable :data-select="dataTable" :is-reset="isReset" @resetOver="resetOver()" />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPage from './HeaderPage.vue';
import DataTable from './DataTable.vue';
import DataUploadDialog from './DialogView/DataUploadDialog.vue';
import ProgressBar from './Utils/ProgressBar.vue';
import http from '@/utils/request.js'
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'MainHome',
  components: {
    HeaderPage,
    DataTable,
    DataUploadDialog,
    ProgressBar
  },
  props: {
    // msg: String
  },
  data() {
    return {
      // uploadFileName: '',
      // isUploadProgress: false,    // 是否显示上传文件进度条
      // uploadProgressPercent: 0,
      // isFileChecked: true,        // 是否显示校验
      // isFileUploadSuccess: false, // 是否上传文件成功

      // isDiagnoseProgress: false,  // 是否显示诊断进度条


      // toDiagnose: false,    // 是否去诊断
      // currentProject: null,


      currentDiagnoseId: '',
      currentTime: '',   // 当前时间，在点击上传文件按钮时，传递给子组件DataUploadDialog
      progressText: '',
      demoName: '',
      fileName: '',
      projectName: '',
      uploadFileUrl: '/kafka/upload/',
      validUrl: '/kafka/valid/',
      diagnosisUrl: '/kafka/dia/',
      // diagnosisUrl: '/diagnosis/dia',      // http通信时使用
      // validUrl: '/file/valid',             // http通信时使用
      // uploadFileUrl: '/folder/upload',     // http通信时使用
      currentPage: 1,
      pageSize: 10,
      progressPercent: 0,
      diagnoseProgress: 0,
      currentLanguageFlag: null,    // 当前语言：0中文；1英文
      times: null,
      file: null,
      elProgress: false,


      isReset: false,
      dialogVisible: false,

      demoList: [
        'battery_data.csv',
        // 'battery_data.txt',
        // 'battery_data.xls',
        'battery_data.zip'
      ],
      fileList: [],
      allData: [],
      dataTable: [],
      uploadFileList: [],
      calculateFileList: [],
      diagnoseIdList: [],       // 诊断中的报告，需要去获取进度条
      projectList: [],
      toDiagnoseList: [],
      currentFileIdList: []     // 当前压缩包解压出来的文件id数组
    };
  },
  created() {
    this.getData()
    this.updatePage()
    setInterval(this.updatePage, 5000);

  },

  methods: {

    ...mapMutations(['setCurrentFileList', 'setIsUploadProgress', 'setIsFileChecked', 'setIsFileUploadSuccess', 'setToDiagnose',
      'setUploadFileName', 'setIsDiagnoseProgress', 'setUploadProgressPercent', 'setValidStatus', 'setCurrentProject',
      'setCurrentFolderId', 'setValidatedList']),

    // 点击切换语言，
    languageChange(value) {
      this.currentLanguageFlag = value
      // console.log('点击切换语言：'+this.currentLanguageFlag)
    },

    resetOver() {
      this.isReset = false
    },
    async updatePage() {
      // console.log('isUploadProgress:', this.isUploadProgress, 'isFileChecked:', this.isFileChecked,
      //   'toDiagnose:', this.toDiagnose, 'currentFileList:', this.currentFileList)
      if (this.isUploadProgress && !this.isFileChecked && this.currentFolderId != '') {
        await this.checkFile()
        console.log('checkFile1')
      }
      if (this.diagnoseIdList.length) {
        await this.getProgress()
      }
    },

    async getProgress() {
      var _this = this
      await http.post('/proxy_url' + '/diagnosis/progress', { 'diagnosisIdList': this.diagnoseIdList }).then(function (response) {
        if (response.data.code == 200) {

          var dianoseResult = response.data.data
          dianoseResult.forEach((item) => {
            if (item.diagnosisId == _this.currentDiagnoseId) {
              if (!item.diagnosisStatus) {
                _this.diagnoseProgress = item.diagnosisReport

              }
              else {
                _this.diagnoseProgress = 100
              }

              if (_this.allData.length == 0) {
                _this.allData.unshift(item)
              } else if (_this.allData[0].diagnosisId != _this.currentDiagnoseId) {
                _this.allData.unshift(item)
              }

            }
          })
          _this.diagnoseIdList = []
          dianoseResult.forEach((item) => {
            _this.allData.forEach((it) => {
              if (it.diagnosisId == item.diagnosisId) {
                it.diagnosisReport = item.diagnosisReport
                it.diagnosisStatus = item.diagnosisStatus
                it.reportPath = item.reportPath
              }
            })
            if (!item.diagnosisStatus) {
              _this.diagnoseIdList.push(item.diagnosisId)
            }
          })
        }
        _this.updateTable()
      })
    },

    async diagnoseNow(data) {
      this.dialogVisible = false
      try {
        await this.createNewProject(data[0], data[1])
        await this.uploadFile()
      } catch (error) {
        console.log(error)
      }
      // this.setToDiagnose(true)
      this.fileList = []
    },

    async diagnoseLater(data) {
      this.dialogVisible = false
      await this.createNewProject(data[0], data[1])
      this.fileList = []
    },

    // 诊断
    async diagnose() {
      this.currentFileList.forEach((item) => {
        this.currentFileIdList.push(item.fileId)
      })
      // console.log(this.currentFileIdList)
      var data = {
        "fileIdList": this.currentFileIdList,
        "languageFlag": this.currentLanguageFlag
      }
      // console.log('diagnosing：' + this.currentLanguageFlag)
      var _this = this
      await http.post('/proxy_url' + this.diagnosisUrl, data).then(function (response) {
        if (response.data.code == 200) {
          _this.currentDiagnoseId = response.data.data.diagnosisId
          _this.diagnoseIdList.push(_this.currentDiagnoseId)
        }
      })
    },

    // 校验
    async checkFile() {
      var _this = this
      await http.post('/proxy_url' + this.validUrl, { "folderId": this.currentFolderId, "toValidFileIdList": this.toValidFileIdList }, setTimeout(5000)).then(function (response) {
        if (response.data.code == 200) {
          if (response.data.data == null) {
            return
          }
          _this.setCurrentFileList(response.data.data.fileList)
          _this.currentFileList.forEach((item) => {
            if (item.validStatus == 0) {
              return
            } else if (item.validStatus == -1) {
              _this.setIsFileChecked(true)
              _this.setIsFileUploadSuccess(false)
              _this.$message.error(_this.$t("validationFailed"))
              return
            } else {
              _this.setIsFileChecked(true)
              _this.setIsFileUploadSuccess(true)
              _this.setToDiagnose(true)
            }
          })



          // if (_this.validStatus == '0') {
          //   return
          // }
          // if (_this.validStatus == '1') {
          //   _this.setIsFileChecked(true)
          //   _this.setIsFileUploadSuccess(true)
          //   _this.setToDiagnose(true)
          //   return
          // }
          // _this.setIsFileChecked(true)
          // _this.setIsFileUploadSuccess(false)
          // return
        } 
      })

      if (this.toDiagnose && this.isFileUploadSuccess) {
        this.setIsDiagnoseProgress(true)
        // console.log('checkFile-setIsDiagnoseProgress', this.isDiagnoseProgress)
        await this.diagnose()
        this.setToDiagnose(false)
        this.setCurrentFolderId('')
        this.currentFileList = []
      }

    },

    // 上传文件
    async uploadFile() {
      // this.setToDiagnose(false)//?
      var _this = this
      var formdata = {
        "projectId": this.currentProject['projectId'],
      }
      var fileLoad = new FormData()
      fileLoad.append('file', this.file.raw)
      fileLoad.append('data', JSON.stringify(formdata))
      this.setUploadFileName(this.fileName)
      this.fileName = ''
      this.setIsUploadProgress(true)
      this.setIsFileChecked(false)
      this.setIsFileUploadSuccess(false)
      this.setIsDiagnoseProgress(false)
      console.log('uploadFile-IsDiagnoseProgress:', this.isDiagnoseProgress)
      await http({
        method: 'post',
        url: this.uploadFileUrl,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        baseURL: '/proxy_url',
        data: fileLoad,
        onUploadProgress: progressEvent => {
          if (progressEvent.event.lengthComputable) {
            this.setUploadProgressPercent(parseInt((progressEvent.event.loaded / progressEvent.event.total) * 100))
          }
        },
      }).then(function (response) {
        if (response.data.code == 200) {
          _this.setCurrentFolderId(response.data.data.folderId)
        } else if (response.data.code == 3001) {
          _this.$message.error(_this.$t("uploadFailed"))
        }
      })
      this.fileList = []
    },

    // 创建项目
    async createNewProject(projectName, dataType) {
      var _this = this
      await http.post('/proxy_url' + '/project/add', { "projectName": projectName, "dataType": dataType }).then(function (response) {
        console.log('项目名：', response.data.code)
        if (response.data.code == 200) {
          _this.setCurrentProject(response.data.data)
          _this.projectList.push(_this.currentProject['name'])
        }else if(response.data.code == 7002){
          _this.$message.error(_this.$t("projectNameRepeat"))
        }
      })
    },

    closeDialog() {
      this.dialogVisible = false
    },

    async getData() {

      // 初始化识别语言
      this.languageRecognize(this.$i18n.locale)
      // console.log('初始化语言：' + this.currentLanguageFlag)

      // 获取所有诊断
      var _this = this
      http.post('/proxy_url' + '/diagnosis/select-all').then(function (response) {
        _this.allData = []
        _this.projectList = []
        _this.diagnoseIdList = []
        if (response.data.data == null) {
          return
        }
        response.data.data.forEach((item) => {
          if (!item.diagnosisStatus) {
            _this.diagnoseIdList.push(item.diagnosisId)
          }
          _this.allData.push(item);
          if (!_this.projectList.includes(item['projectName'])) {
            _this.projectList.push(item['projectName'])
          }
          // if(_this.projectName!=''){
          //   _this.dataTable=_this.allData.filter(i=>
          //     i.name==_this.projectName
          //  )
          // }
          // else{
          //   _this.dataTable=_this.allData.slice(_this.pageSize*(_this.currentPage-1),_this.pageSize*_this.currentPage)
          // }
          // let cnt=1
          // _this.dataTable.forEach((item)=>{
          //   item['number']=cnt
          //   cnt+=1
          // })
        })
        _this.updateTable()
      })
    },
    // 语言标志识别
    languageRecognize(value) {
      if ('zh' == value) {
        this.currentLanguageFlag = 0
      } else if ('en' == value) {
        this.currentLanguageFlag = 1
      }
    },

    showDataUpdateDialog() {
      if (this.fileList.length == 0) {
        this.$message.error(this.$t('Main.No_file_selected'));
        return;
      }
      this.dialogVisible = true
      // 每次点击按钮，将当前时间赋值给this.currentTime
      this.getCurrentTime()
    },
    getCurrentTime() {
      let month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMinutes() + 1
      let day = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
      let hour = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
      let min = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      this.currentTime = `${month}${day}${hour}${min}`
    },
    async downloadTemplate() {
      if (this.demoName == '') {
        this.$message.error(this.$t('Main.selectDataTemplate'));
        return
      }
      await http.get('file/' + this.demoName, {
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        let fname = this.demoName;
        link.href = url;
        link.setAttribute('download', fname);
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.log('error:' + JSON.stringify(error))
      });
    },
    getFile(event) {
      this.file = event.target.files[0];
    },
    check(file, fileList) {
      this.isDisabled = false
      if (!file) return
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isLt500M = file.size / 1024 / 1024 < 500
      if (testmsg !== 'zip') {
        this.$refs.upload.clearFiles()
        this.$message.error({
          message: this.$t('Main.zip'),
          type: 'warning'
        })
        return false
      }
      if (!isLt500M) {
        this.$refs.upload.clearFiles()
        this.$message({
          message: this.$t('Main.fileSize'),
          type: 'warning'
        })
        return false
      }
      fileList = fileList.slice(-1);
      this.fileList = fileList;
      this.file = file
      this.fileName = file.name;
    },
    // changePage(curPage){
    //   this.currentPage=curPage
    //   this.updateTable()
    // },

    // changeSize(curSize){
    //   this.pageSize=curSize
    //   this.updateTable()
    // },

    updateTable() {
      if (this.projectName != '') {
        this.dataTable = this.allData.filter(i =>
          i.projectName == this.projectName
        )
      }
      else {
        this.dataTable = this.allData
      }
      let cnt = 1
      this.dataTable.forEach((item) => {
        item['number'] = cnt
        cnt += 1
      })
    },
    resetTable() {
      this.projectName = ''
      // this.pageSize = 10
      // this.currentPage =1
      this.updateTable()
      this.isReset = true
    }
    // handleProgress(event){
    //   console.log(66666666666666666666666)
    //   console.log(event)
    //     this.elProgress = true
    //     //使用定时器来制作进度条
    //     this.times = setInterval(() => {
    //         this.uploadProgressPercent++
    //         if (this.uploadProgressPercent > 90) {
    //             clearInterval(this.timer)
    //             this.times = null
    //         }
    //         console.log(this.uploadProgressPercent)
    //     }, 1)
    // }
  },
  watch: {
    projectName: {
      handler(newVal) {
        this.projectName = newVal
        this.updateTable()
      }
    }
  },
  computed: {
    ...mapState(['isFileChecked', 'isUploadProgress', 'currentFolderId', 'isFileUploadSuccess', 'toDiagnose'
      , 'uploadFileName', 'isDiagnoseProgress', 'uploadProgressPercent', 'validStatus', 'currentProject', 'toValidFileIdList'
      , 'validatedList', 'currentFileList'])

  }
}

</script>
<style>
.bm-overlay {
  background: #fff !important;
}

.bm-menu {
  height: 50%;
  /* 100% Full-height */
  width: 0;
  /* 0 width - change this with JavaScript */
  position: fixed;
  /* Stay in place */
  z-index: 1000;
  /* Stay on top */
  top: 0;
  left: 0;
  box-shadow: -1px 0px 10px 0px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  /* Black*/
  overflow-x: hidden;
  /* Disable horizontal scroll */
  padding-top: 60px;
  transition: 0.5s;
}

input#file-upload-button {
  display: none;
}
</style>
<style lang="less" scoped>
/deep/ .bm-overlay {
  background: #fff;
}

/deep/ .bm-menu {
  height: 50%;
  /* 100% Full-height */
  width: 0;
  /* 0 width - change this with JavaScript */
  position: fixed;
  /* Stay in place */
  z-index: 1000;
  /* Stay on top */
  top: 0;
  left: 0;
  box-shadow: -1px 0px 10px 0px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  /* Black*/
  overflow-x: hidden;
  /* Disable horizontal scroll */
  padding-top: 60px;
  transition: 0.5s;
}
</style>





